import { render, staticRenderFns } from "./InformacoesGeraisEvolui.vue?vue&type=template&id=7f576e0d&scoped=true"
import script from "./InformacoesGeraisEvolui.vue?vue&type=script&lang=js"
export * from "./InformacoesGeraisEvolui.vue?vue&type=script&lang=js"
import style0 from "./InformacoesGeraisEvolui.vue?vue&type=style&index=0&id=7f576e0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f576e0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
